var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href}},[_c('document-view',{attrs:{"document":_vm.document},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('div',{staticClass:"download"},[_c('download-icon')],1)]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }